import {isNotNullUndefinedOrFalse} from '@wandb/common/util/types';

export function isOneOf(v: any, values: any[]): boolean {
  return values.indexOf(v) > -1;
}

export function getDomainFromEmail(email: string): string {
  return email.substring(email.lastIndexOf('@') + 1);
}

export function removeNullUndefinedOrFalse<T>(
  arr: Array<T | null | undefined | false>
): T[] {
  return arr.filter(isNotNullUndefinedOrFalse);
}
